import React from 'react'
import { connect } from 'react-redux'
import Terms from '../../components/utilities/Terms'
import { bindActionCreators } from 'redux'
import { showPopup } from '../../actions/uiActions'


class TermsContainer extends React.Component {

    render() {
        return (
            <Terms showPopup={this.props.showPopup} />
        )
    }
}

function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ showPopup }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TermsContainer)